import { Box, Container, Stack } from '@mantine/core';
import GameHeader from './GameHeader';
import FullscreenBackground from './FullscreenBackground';

export default function GameScreen({
  gameName,
  roomCode,
  onReconnect,
  onQuit,
  timerSeconds,
  background,
  backgroundImage,
  scroll = false,
  container = true,
  children,
}) {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
      <GameHeader
        gameName={gameName}
        roomCode={roomCode}
        onReconnect={onReconnect}
        onQuit={onQuit}
        timerSeconds={timerSeconds}
      />
      {backgroundImage && !children ? (
        <FullscreenBackground image={backgroundImage} />
      ) : (
        <Box style={{ flex: 1, overflow: scroll ? 'auto' : 'hidden', background }}>
          {container ? (
            <Container size="sm" p="md" h={scroll ? undefined : '100%'}>
              <Stack h={scroll ? undefined : '100%'} style={scroll ? undefined : { overflow: 'hidden' }}>
                {children}
              </Stack>
            </Container>
          ) : (
            children
          )}
        </Box>
      )}
    </Box>
  );
}
